import React from 'react'
import ReactDOM from 'react-dom'
import { Helmet } from 'react-helmet'
import { NotificationManagerProvider, OIOProvider } from 'oio-react'
import { BrowserRouter, Link } from 'react-router-dom'
import { init as initSentry } from '@sentry/browser'
import { sentryDsn } from 'config/constants'
import uiConstants from 'config/constants/ui'
import GlobalApp from 'src/apps/Global'
import ApolloProvider from 'src/apps/Global/components/ApolloProvider'
import ErrorBoundary from 'src/components/App/ErrorBoundary'
import { MyNotificationCountProvider } from 'src/graphql/contexts/MyNotificationCount'
import { OrganizationProvider } from 'src/graphql/contexts/Organization'

import 'react-dates/initialize'
import './style.less'

initSentry({
   dsn: sentryDsn,
   environment: process.env.NODE_ENV,
   release: process.env.CV5_RELEASE_ID,
   sampleRate: process.env.NODE_ENV === 'production' ? 1 : 0
})

const oioButtonLinkAdapter = {
   render: ({ linkTo, linkReplace, linkExact, ...props }) => (
      <Link to={linkTo} replace={linkReplace} {...props} />
   )
}

ReactDOM.render((
   <OIOProvider
      buttonLinkAdapter={oioButtonLinkAdapter}
      fontFamily="neue-haas, Helvetica Neue, Helvetica, sans-serif">
      <ErrorBoundary>
         <Helmet defaultTitle="Communities" />
         <ApolloProvider>
            <BrowserRouter>
               <NotificationManagerProvider zIndex={uiConstants.zIndexes.notificationManager}>
                  <OrganizationProvider>
                     <MyNotificationCountProvider>
                        <GlobalApp />
                     </MyNotificationCountProvider>
                  </OrganizationProvider>
               </NotificationManagerProvider>
            </BrowserRouter>
         </ApolloProvider>
      </ErrorBoundary>
   </OIOProvider>
), document.getElementById('container'))

if (module.hot) {
   module.hot.accept()
}
